import React, { Component } from 'react';
import { SignUpLink } from './SignUp';
import { PasswordForgetLink } from './ForgotPassword';
import { doSignIn } from '../../session';

const SignInPage = ({onSubmit,history}) =>
  <div>
    <h1>SignIn</h1>
    <SignInForm history={history} onSubmit={onSubmit} />
    <PasswordForgetLink />
    <SignUpLink />
  </div>

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class SignInForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

    handleChange(e) {
      const target = e.target;
      const name = target.name;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      
      this.setState({
        [name]: value
      });
    }

  onSubmit(e) {
    e.preventDefault();
    const { email, password } = this.state;
    

    doSignIn(email, password)
       .then((x) => {
        this.setState(() => ({ ...INITIAL_STATE }));
        this.props.history.goBack();
      })
      .catch(error => {
        this.setState({error:error});
      });


   

  }

  render() {
    const { email, password, error, } = this.state;
    const isInvalid = password === '' || email === '';

    return (
      <form onSubmit={this.onSubmit}>
        <input type="text" name="email" value={email} onChange={this.handleChange}  placeholder="Email Address" />
        <input type="password" name="password" value={password} onChange={this.handleChange}  placeholder="Password" />
        <div className="button-footer">
             <button disabled={isInvalid}>Sign In</button>
        </div>
        { error && <p>{error.message}</p> }
      </form>
    );
  }
}

export default SignInPage;

export {
  SignInForm,
};



// WEBPACK FOOTER //
// ./src/components/Account/SignIn.js